import { ErrorToast } from '../utils/Utils';

export const findCategoryById = (data, categoryId) =>
  data.departments
    .map((department) => department.categories)
    .flat()
    .find((category) => category.id === categoryId) || null;
export const getType = (id, collections) => {
  const group = Object.entries(collections).find(([, items]) => items.some((item) => item.id === id));
  if (group) {
    const [, items] = group;
    const foundItem = items.find((item) => item.id === id);
    return foundItem ? foundItem.type : null;
  }
  return null;
};

export const validate = (data) => {
  let invalid = false;
  if (data?.name?.length > 40) {
    invalid = true;
    ErrorToast('Category name character limit is 40.');
  }
  if (!data?.name) {
    invalid = true;
    ErrorToast('Enter a category name.');
  }
  if (data?.name?.trim().length === 0) {
    invalid = true;
    ErrorToast('Enter a valid category name.');
  }
  return invalid;
};
